import downloadIcon from "../../../images/icons/download_dark.svg";
import pdfIcon from "../../../images/icons/pdf_icon.svg";

const Certificates = () => {
  const certificates = [
    // Раздел «Декларации/Сертификаты ТР ТС»
    {
      name: "Декларация ТР ТС на EPP",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.РА09.В.37125_24 - EPP.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EVR",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.РА09.В.37125_24 - EVR.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EST",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.РА09.В.37125_24 - EST.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на DHT",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.РА09.В.37125_24 - DHT.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на WQ(D)",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.РА07.В.09437_25 - WQ(D).pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на DLT",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA11.B.12647_24 - DLT.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на GPD",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA11.B.12647_24 - GPD.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EVS",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - EVS.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на KBZ, KBS",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - KBZ, KBS.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на ECH(S), EDH",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - ECH(S), EDH.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EEZ, EEP",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - EEZ, EEP.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EMS",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - EMS.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EDSE, EDSU, EDSP",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - EDSE, EDSU, EDSP.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Сертификат ТР ТС на EWC",
      path: "/docs/certificates/Сертификат ЕАЭС KG417_026.CN.02.02386 - EWC.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EBK",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - EBK.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на ESST",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - ESST.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },
    {
      name: "Декларация ТР ТС на EVP",
      path: "/docs/certificates/Декларация ЕАЭС N RU Д-CN.PA05.B.12913_23 - EVP.pdf",
      category: "Декларации/Сертификаты ТР ТС",
    },

    // Раздел «Другое»
    {
      name: "Гигиенический сертификат",
      path: "/docs/certificates/Гигиенический сертификат.pdf",
      category: "Другое",
    },
    {
      name: "Сертификат сейсмостойкости",
      path: "/docs/certificates/Сертификат сейсмостойкости.pdf",
      category: "Другое",
    },
  ];

  const openFile = (path) => {
    if (!path) return;

    const link = document.createElement("a");
    link.href = path;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex-column gap-grid column-start w-100">
      {(() => {
        const categorized = certificates.filter((d) => !!d.category);
        const uncategorized = certificates.filter((d) => !d.category);
        const categories = Array.from(
          new Set(categorized.map((d) => d.category))
        );

        return (
          <>
            {categories.map((cat) => (
              <div className="flex-column gap-grid w-100" key={`cat-${cat}`}>
                <h2>{cat}</h2>
                <div className="cards w-100">
                  {categorized
                    .filter((d) => d.category === cat)
                    .map((item) => (
                      <div
                        className="card-item flex-column column-start flex-between border-radius-base"
                        key={item.path}
                      >
                        <span className="title text-m">{item.name}</span>
                        <div className="flex-row gap-4x">
                          <button
                            type="button"
                            onClick={() => openFile(item.path)}
                            className="download btn-outlined size-m flex-row"
                          >
                            Скачать
                            <img alt="download" src={downloadIcon} />
                          </button>
                          <img src={pdfIcon} alt="pdf document"></img>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ))}

            {uncategorized.length > 0 && (
              <div className="cards w-100">
                {uncategorized.map((item) => (
                  <div
                    className="card-item flex-column column-start flex-between border-radius-base"
                    key={item.path || item.name}
                  >
                    <span className="title text-m">{item.name}</span>
                    <div className="flex-row gap-4x">
                      <button
                        type="button"
                        onClick={() => openFile(item.path)}
                        className="download btn-outlined size-m flex-row"
                      >
                        Скачать
                        <img alt="download" src={downloadIcon} />
                      </button>
                      <img src={pdfIcon} alt="pdf document"></img>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        );
      })()}
    </div>
  );
};

export default Certificates;
